const EXTENSION_MIME: Record<string, string> = {
  ".png": "image/png",
  ".jpg": "image/jpeg",
  ".jpeg": "image/jpeg",
  ".gif": "image/gif",
  ".webp": "image/webp",
  ".svg": "image/svg+xml",
  ".heic": "image/heic",
  ".heif": "image/heif",
  ".mp4": "video/mp4",
  ".webm": "video/webm",
  ".mov": "video/quicktime",
  ".avi": "video/x-msvideo",
}

function fileExtension(name: string): string {
  const dot = name.lastIndexOf(".")
  if (dot < 0) return ""
  return name.slice(dot).toLowerCase()
}

function inferredMime(file: File): string {
  if (file.type) return file.type
  return EXTENSION_MIME[fileExtension(file.name)] ?? ""
}

function matchesAcceptToken(mime: string, token: string): boolean {
  const trimmed = token.trim().toLowerCase()
  if (!trimmed) return false
  if (trimmed.endsWith("/*")) {
    const prefix = trimmed.slice(0, -1)
    return mime.toLowerCase().startsWith(prefix)
  }
  return mime.toLowerCase() === trimmed
}

function parseAcceptTokens(accept: string): string[] {
  return accept
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean)
}

export function filterFilesByAccept(files: File[], accept: string): File[] {
  const tokens = parseAcceptTokens(accept)
  if (tokens.length === 0) return [...files]

  return files.filter((file) => {
    const mime = inferredMime(file)
    if (!mime) return false
    return tokens.some((token) => matchesAcceptToken(mime, token))
  })
}

export function isFileDrag(dataTransfer: DataTransfer): boolean {
  return dataTransfer.types.includes("Files")
}
